import { render, staticRenderFns } from "./free_pay_sucess.vue?vue&type=template&id=e6c1a750&scoped=true"
import script from "./free_pay_sucess.vue?vue&type=script&lang=js"
export * from "./free_pay_sucess.vue?vue&type=script&lang=js"
import style0 from "./free_pay_sucess.vue?vue&type=style&index=0&id=e6c1a750&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6c1a750",
  null
  
)

export default component.exports